var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMypurchase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1580_676)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 250,
    r: 234.316,
    fill: "white",
    stroke: "white",
    strokeWidth: 31.3687
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.516 118.502C154.909 117.399 142.566 116.769 129.75 116.769V337.366C196.454 337.366 250.553 353.806 250.553 374.132",
    fill: "#FEF4E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.516 118.502C154.909 117.399 142.566 116.769 129.75 116.769V337.366C196.454 337.366 250.553 353.806 250.553 374.132",
    stroke: "black",
    strokeWidth: 10.2945,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.748 148.283H98.2344V374.132H250.551V153.535C250.551 118.712 212.945 90.5073 166.514 90.5073V311.104C212.945 311.104 250.551 339.309 250.551 374.132",
    fill: "#FEF4E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.748 148.283H98.2344V374.132H250.551M250.551 374.132V153.535C250.551 118.712 212.945 90.5073 166.514 90.5073V311.104C212.945 311.104 250.551 339.309 250.551 374.132Z",
    stroke: "black",
    strokeWidth: 10.2945,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.872 148.283H250.555V374.132H402.872V148.283Z",
    fill: "#FEF4E8",
    stroke: "black",
    strokeWidth: 10.2945,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.5 375.5L402.86 316.356H350.337C347.551 316.356 344.879 317.463 342.909 319.433C340.939 321.403 339.833 324.075 339.833 326.861V363.627C339.833 366.413 338.726 369.085 336.756 371.055C334.786 373.025 332.114 374.132 329.328 374.132",
    fill: "#FEF4E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.5 375.5L402.86 316.356H350.337C347.551 316.356 344.879 317.463 342.909 319.433C340.939 321.403 339.833 324.075 339.833 326.861V363.627C339.833 366.413 338.726 369.085 336.756 371.055C334.786 373.025 332.114 374.132 329.328 374.132",
    stroke: "black",
    strokeWidth: 10.2945,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.081 221.816V132.526H282.062V221.816L303.072 211.311L324.081 221.816Z",
    fill: "#FEF4E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.172 132.354H324.018V222.024L302.865 213.393L282.172 222.024V132.354Z",
    fill: "#4045A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.562 120.857L161.693 122.467V309.946C161.693 312.435 163.696 314.474 166.18 314.619C175.444 315.162 197.411 317.474 216.415 327.328C238.307 338.68 241.017 353.999 241.017 353.999C241.017 353.999 223.386 343.973 206.069 340.434C187.642 336.668 145.722 332.847 145.722 332.847H137.717C135.975 332.847 134.562 331.434 134.562 329.692V120.857Z",
    fill: "#4045A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.609 152.817H124.912V336.566C124.912 339.162 127.097 341.248 129.693 341.222C140.922 341.112 170.95 341.919 209.294 351.7C231.826 357.448 244.472 369.175 244.472 369.175C244.472 369.175 197.798 369.175 174.115 369.175C155.308 369.175 112.266 369.175 112.266 369.175H106.897C105.161 369.175 103.752 367.772 103.742 366.037L102.609 152.817Z",
    fill: "#4045A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.453 147.068H134.57V330.204C134.57 331.168 135.323 331.961 136.286 332.009C143.933 332.389 175.455 334.073 196.419 336.985C212.054 339.156 230.406 346.872 239.185 353.309C244.499 357.206 244.933 369.174 244.933 369.174C244.933 369.174 231.248 359.303 221.251 355.609C210.674 351.7 203.061 350.405 191.361 347.791C178.609 344.942 171.258 344.452 158.252 343.193C148.689 342.267 135.453 341.486 128.735 341.119C126.336 340.988 124.453 339.006 124.453 336.604V147.068Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1580_676"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    rx: 250,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMypurchase);
export default __webpack_public_path__ + "static/media/mypurchase.f47ed04a32962d7247748d40e5fb77ed.svg";
export { ForwardRef as ReactComponent };